<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Ihre Bankdaten</div>
<ng-container *ngIf="bankingAccount.inherit">
    Kontoinhaber wie Auftraggeber<br />
</ng-container>
<ng-container *ngIf="!bankingAccount.inherit">
    Kontoinhaber:<br />
    {{ bankingAccount.firstName }} {{ bankingAccount.lastName }}<br />
</ng-container>
IBAN: {{ bankingAccount.iban }}<br />
BIC: {{ bankingAccount.bic }}<br />
Kreditinstitut: {{ bankingAccount.creditInstitution }}<br />
<ng-container *ngIf="bankingAccount.authorize">
    Teilnahme am Lastschriftverfahren<br />
</ng-container>
<br />
<ng-container *ngIf="billingAddress.inherit">
    Rechnungsanschrift wie Auftraggeber<br />
</ng-container>
<ng-container *ngIf="!billingAddress.inherit">
    Rechnungsanschrift:<br />
    {{ billingAddress.title }} {{ billingAddress.firstName }} {{ billingAddress.lastName }}<br />
    {{ billingAddress.streetName }} {{ billingAddress.streetNumber }}<br />
    {{ billingAddress.postalCode }} {{ billingAddress.city }}<br />
</ng-container>
Rechnung nur per E-Mail<br />
